import { Dispatcher } from 'flux';
import _ from 'underscore';
import Store from './store/index.js';
import ActionCreator from './action_creator/index.js';

// Native keyMirror implementation (replaces mirrorkey dependency)
const keyMirror = (keys) => {
  const mirrored = {};
  keys.forEach((key) => {
    mirrored[key] = key;
  });
  return mirrored;
};

const stores = [];
const actionCreators = [];

const Flux = function (storeStates) {
  this._dispatcher = new Dispatcher();
  this.storeStates = storeStates;
};

Flux.prototype.getStoreState = function (storeName) {
  if (this.storeStates !== undefined) {
    return this.storeStates[storeName];
  }
};

Flux.createStore = function (proto) {
  const thisStore = Store.extend(proto);
  const store = new thisStore();
  stores.push(store);
  return store;
};

Flux.createConstants = function (constDefinition) {
  let messages = [];
  /* Add service messages */
  if (constDefinition.serviceMessages) {
    _.each(constDefinition.serviceMessages, function (serviceMessage) {
      messages.push(serviceMessage);
      messages.push(`${serviceMessage}_COMPLETED`);
      messages.push(`${serviceMessage}_FAILED`);
    });
  }

  /* Add normal messages */
  if (constDefinition.messages) {
    messages = _.union(messages, constDefinition.messages);
  }

  return _.extend({}, keyMirror(messages), constDefinition.values);
};

Flux.createActionCreator = function (proto) {
  const thisActionCreator = ActionCreator.extend(proto);
  const actionCreator = new thisActionCreator();
  actionCreators.push(actionCreator);

  return actionCreator;
};

Flux.start = function (storeStates) {
  const flux = new Flux(storeStates);
  _.each(stores, function (store) {
    store.mount(flux);
  });
  _.each(actionCreators, function (actionCreator) {
    actionCreator.mount(flux);
  });

  return flux;
};

export default _.extend(Flux, { Stores: stores });
